import React from "react";
import FeatureCard from "./FeatureCard";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import f1 from "../../assets/f1.png";
import f2 from "../../assets/f2.png";
import f3 from "../../assets/f3.png";
import f4 from "../../assets/f4.png";
import f5 from "../../assets/f5.png";
import f6 from "../../assets/f6.png";

const featureData = [
  {
    id: 1,
    name: "OBE ভিত্তিক কারিকুলাম",
    image: f1,
  
  },
  {
    id: 2,
    name: "শিক্ষক প্রশিক্ষণ",
    image: f2,
    
  },
  {
    id: 3,
    name: "পাঠদান কৌশল",
    image: f3,
  },
  {
    id: 4,
    name: "মূল্যায়ন পদ্ধতি",
    image: f4,
  },
  {
    id: 5,
    name: "মান নিয়ন্ত্রণ (IQAC)",
    image: f5,
    
  },
  {
    id: 6,
    name: "এক্রিডিটেশন",
    image: f6,
   
  },
];

const Features = () => {
  return (
    <Link to="/qs-academy/smart-school/" className="w-full bg-[#101e2b] flex justify-center items-center py-[4rem]">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: false }}
        className="container flex flex-col gap-4 px-4 sm:px-0"
      >
        <div className="text-center my-[1rem]">
          <h2 className="sm:text-5xl text-3xl font-bold text-white">
            QS স্মার্ট স্কুল{" "}
            <span className="text-[#22beff]">ফ্র্যাঞ্চাইজি</span> সুবিধা
          </h2>
          <p className="text-white text-center text-xl mt-4">
            আপনার বর্তমান ট্রাডিশনাল শিক্ষাপ্রতিষ্ঠানকে স্মার্ট শিক্ষাপ্রতিষ্ঠান
            করতে আজই ফ্র্যাঞ্চাইজি নেন
          </p>
        </div>
        <div className="grid sm:grid-cols-3 grid-cols-2 gap-4 mt-[2rem]">
          {featureData.map((item, index) => {
            return <FeatureCard key={index} data={item} index={index} />;
          })}
        </div>
      </motion.div>
    </Link>
  );
};

export default Features;
